import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BoardComponent } from './board/board.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxEditorModule } from "ngx-editor";
import { NgbAlertModule, NgbCarouselModule, NgbCollapseModule, NgbDropdownModule, NgbModule, NgbNavModule, NgbProgressbarModule } from '@ng-bootstrap/ng-bootstrap';
import { ColourPickerComponent } from './colour-picker/colour-picker.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import { FilterPipe } from './shared/filter.pipe';
import { SafePipe } from './shared/sanitize.pipe';
import { AngularFireModule} from '@angular/fire/compat'
 import { environment } from 'src/environments/environment';
import { AudioRecorderService } from './shared/audio-recorder.service';
import { RootComponent } from './root/root.component';
import { HeaderIntercepterService } from './shared/header-interceptor';
import { ErrorHandlingInterceptorService } from './shared/retry-interceptor.service';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';
import { ToastrModule } from 'ngx-toastr';
import { ToastrService } from 'ngx-toastr';
import { FilterByTypePipe } from './shared/board-filter-pipe';
import { SimplebarAngularModule } from 'simplebar-angular';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { LoaderComponent } from './loader/loader.component';
import { TruncatePipe } from './shared/truncate';
import { boardFilter } from './shared/boardfilter';
import { inviterUser } from './shared/inviteruserPipe';
import { NetworkInterceptor } from './shared/network-intercepter';
export function HttpLoaderFactory(httpClient: HttpClient): TranslateHttpLoader {
  const version =  new Date().getTime();// Define your version or use a dynamic value
  return new TranslateHttpLoader(httpClient, `/assets/i18n/`, `.json?v=${version}`);
}

@NgModule({
  declarations: [
    AppComponent,
    BoardComponent,
    ColourPickerComponent,
    FilterPipe,
    boardFilter,
    SafePipe,
    RootComponent,
    FilterByTypePipe,
    LoaderComponent ,
    TruncatePipe  ,
    inviterUser,
     ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule  ,
    HttpClientModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    NgxEditorModule,
    NgbModule,
    OverlayModule,
    NgbDropdownModule,
    NgbProgressbarModule,
    NgbNavModule,
    SimplebarAngularModule,
    NgbAlertModule,
    NgbCollapseModule,
    PortalModule,
    DragDropModule,
     AngularFireModule.initializeApp(environment.firebase),
     SweetAlert2Module.forRoot(),
     ToastrModule.forRoot( {timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,
      progressBar: true,
      closeButton: true}),
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      }
  })
    
  ],
  providers: [AudioRecorderService,HeaderIntercepterService,ErrorHandlingInterceptorService,
    provideAnimations(), // required animations providers
    provideToastr(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NetworkInterceptor,
      multi: true,
    },
    ToastrService,
    { provide: HTTP_INTERCEPTORS, useClass: ErrorHandlingInterceptorService, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HeaderIntercepterService, multi: true }

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
